


















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ReportDatasourcesForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        typeId: {
            id: null
        }
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        datasourceName: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 50) || 'Field must be less than 50 characters'
        ],
        datasourceHost: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 100) || 'Field must be less than 100 characters'
        ],
        datasourcePort: [
            (v: number) => !!v || 'This field is required',
            (v: number) => (v && v.toString().length <= 10) || 'Field must be less than 10 characters'
        ],
        datasourceDatabase: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 50) || 'Field must be less than 50 characters'
        ],
        datasourceUsername: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 50) || 'Field must be less than 50 characters'
        ]
    }

    formModel: {[key: string]: object[]} = {
        roleTypes: []
    }

    mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }
        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Report Datasource'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Report Datasource'
            this.data = {}
            this.loading = false
            break
        }
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getReportDatasourcesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ReportDatasourcesStore.reportDatasourceForm
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editDatasources', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Datasources'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
                .catch(error => {
                    console.log('catch', error)
                })
            break
        case 'add':
            this.$store.dispatch('createDatasources', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Datasources'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
                .catch(error => {
                    this.buttonLoading = false
                    console.log('catch', error)
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
